// turns an object into an encoded set of key-value pairs,
// separated by & and prepended with ? suitable for use as a query string.
// if the params object is empty, returns an empty string.
export const queryify = (params = {}) => {
  const query = Object.entries(params).filter(([, val]) => val !== undefined).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join('&');
  return query ? `?${query}` : '';
};
